import { Vector2 as e } from "three";
const n = (o, t = 1) => {
  const r = o.toArray();
  return r.splice(t, 1), new e().fromArray(r);
};
export {
  n as Vector3ToVector2
};
//# sourceMappingURL=index35.js.map
